import { Flex, QueryLoader, RichEmptyState } from "@jsq/ds/core";
import { resultHasErrorWithErrorCode } from "~/common/utils/errors";
import { useGetFamilyHistoryQuery, useGetCaseHistoryQuery } from "~/graphql/supergraphHooks";
import { BILLING_PERMISSION_DENIED_ERROR_CODE } from "~/pages/Billing/constants";
import { ActivityTimeline } from "./LogTab/ActivityTimeline";
import * as styles from "./styles_vanilla.css";

type LogTabProps = {
  familyId: string | null;
  billingCaseId: number;
  changeRequestId: string;
};

export const LogTab = ({ familyId, billingCaseId, changeRequestId }: LogTabProps) => {
  const isFCCCase = !familyId && changeRequestId !== "";

  const familyHistoryResult = useGetFamilyHistoryQuery({
    variables: { familyId: familyId ?? "", billingCaseId },
    skip: !familyId,
    fetchPolicy: "network-only",
  });

  const caseHistoryResult = useGetCaseHistoryQuery({
    variables: { changeRequestId },
    skip: !isFCCCase,
    fetchPolicy: "network-only",
  });

  const result = isFCCCase ? caseHistoryResult : familyHistoryResult;
  const entries = isFCCCase
    ? (caseHistoryResult.data?.getCaseHistory?.entries ?? [])
    : (familyHistoryResult.data?.getFamilyHistory?.entries ?? []);

  const isPermissionDenied = resultHasErrorWithErrorCode(
    result,
    BILLING_PERMISSION_DENIED_ERROR_CODE,
  );

  const renderPermissionDeniedError = () => (
    <RichEmptyState
      illustration="searching"
      title="Access restricted"
      description="You don't have permission to view the activity log for this billing group."
    />
  );

  return (
    <Flex flexDirection="column" className={styles.logTabContainer}>
      <QueryLoader
        result={result}
        renderError={isPermissionDenied ? renderPermissionDeniedError : undefined}
      >
        <ActivityTimeline entries={entries} />
      </QueryLoader>
    </Flex>
  );
};
